<template>
  <div class="track-replay-wrap">
    <Control @replay="search" :model="model" :rules="rules" :loading="loading" />
    <DeviceMap class="replay-map" @loaded="mapLoaded">
      <div class="map-control">
        <GradientBar :max="max" :gradient="gradient" width="100px" unit="TVOC (ppm)" />
      </div>
      <ProgressBar
        ref="progressBar"
        v-bind="progressBarConfig"
        :speed="speed"
        @change="handleChange"
        @jumpto="handleJumpto"
      />
    </DeviceMap>
  </div>
</template>

<script>
import Control from './components/control';
import DeviceMap from '../../trackMonitor/components/map.vue';
import ProgressBar from '@/components/progressBar';
import GradientBar from '@/components/gradientBar';
import { trackReplay, getTrackParam } from '@/api/track';
import { closeWindowListener } from '@/utils/socket';
import { toTimestamp } from '@/utils/date';
import { findIndexByRange, getRange, toBmapCoordinate, toPointGeoJson } from '@/utils/bmapUtil';
import { timer } from '@/utils/utils';
// import mockData from './utils/mock';

export default {
  components: { Control, DeviceMap, ProgressBar, GradientBar },
  data() {
    let { beginTime, endTime, id, sn } = this.$route.query;
    beginTime = +beginTime;
    endTime = +endTime;
    return {
      sn,
      map: null,
      loading: false,
      currIndex: -1,
      speed: 2,
      max: 10,
      gradient: {
        // 对应比例渐变色
        0: 'rgba(0,0,128,1)',
        0.125: 'rgba(0,4,255,1)',
        0.376: 'rgb(2,255,255)',
        0.62: 'rgba(254,255,1,1)',
        0.87: 'rgba(255,0,0,1)',
        '1.0': 'rgba(130,0,0,1)'
      },
      model: {
        speed: 2,
        beginTime: beginTime,
        endTime: endTime,
        id
      },
      rules: {
        speed: [{ required: true, message: '请选择回放速度', trigger: 'change' }]
      },
      progressBarConfig: {
        range: [beginTime, endTime],
        cacheRanges: []
      },
      dataCache: {}
    };
  },
  methods: {
    search() {
      this.speed = this.model.speed;
      this.$nextTick(() => {
        this.$refs.progressBar.autoPlay(1);
      });
    },
    async getData() {
      try {
        this.loading = true;
        const res = await trackReplay(this.model);
        const { centerPosition, data } = res.data || {};
        // const { centerPosition, data } = mockData;
        const range = [+this.model.beginTime, +this.model.endTime];
        const times = Object.keys(data);
        times.forEach(time => {
          const item = data[time];
          if (!item) return;
          this.dataCache[toTimestamp(time)] = Object.values(item)[0];
        });
        this.progressBarConfig.cacheRanges.splice(0, Infinity, range);
        this.$refs.progressBar.restart();
        this.map.locateTo({ center: centerPosition, zoom: 18 });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async handleChange(time) {
      const times = Object.keys(this.dataCache);
      const range = getRange(time, 10);
      const index = findIndexByRange(times, range);

      if (index === -1 || this.currIndex === index) return null;
      this.currIndex = index;

      /** @type {{longitude: number,latitude: number, runstate: number, state: number, tvocPid: number}[], max: number} */
      const list = Object.values(this.dataCache).slice(0, index).filter(Boolean);

      const coordinates = list.map(e => [e.longitude, e.latitude]);
      const p = await toBmapCoordinate({ coordinates });
      const max = (list.slice(-1)[0] || {}).max;
      if (max && max !== this.max) this.max = max;

      const data = list.map((e, i) => {
        if (!p[i]) return false;
        return toPointGeoJson(p[i], (e.tvocPid / e.max) * 100);
      });
      this.map.resetHeatGridData(data);
    },
    handleJumpto() {
      timer(() => this.map.updateInterval());
    },
    unsubscribe() {
      // TODO 取消走航回放订阅
      // this.$socket.emit('/socket/unsubscribe/trackReplay', this.model.id);
    },
    mapLoaded(map) {
      this.map = map;
      this.getData();
    },
    async initMapParams() {
      const res = await getTrackParam(this.sn);
      if (!res || !res.data || !res.data.deviceMapParamItems) return;
      const items = res.data.deviceMapParamItems;

      const params = {};
      items.forEach(e => {
        params[e.itemCode] = e.value;
      });
      if (params.gradient) {
        this.gradient = JSON.parse(params.gradient);
      }

      if (params.max) {
        this.max = +(params.max || 10);
      }
    }
  },
  mounted() {
    this.initMapParams();
    this.removeListener = closeWindowListener(() => {
      this.unsubscribe();
    });
  },
  beforeDestroy() {
    this.unsubscribe();
    this.removeListener && this.removeListener();
  }
};
</script>

<style lang="scss">
.track-replay-wrap {
  height: 100%;
  .replay-map {
    height: calc(100% - 80px) !important;
  }
  .control-wrap {
    position: absolute;
    z-index: 10;
    right: 30px;
    top: 30px;
    text-align: right;

    .block {
      display: flex;
      align-items: center;
      width: 140px;
      .label {
        display: inline-block;
        color: #49c7c3;
        min-width: 48px;
        text-align: right;
      }
      .radius-slider {
        flex: 1;
      }
    }
  }
  .map-control {
    position: absolute;
    right: 15px;
    top: 20px;
    z-index: 10;
  }
}
</style>
